export function ConnectionLineLong(props) {
  const { className, stroke, ...rest } = props;
  return (
    <svg width='9' height='118' viewBox='0 0 9 118' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <path d='M-2.38419e-07 117H4C6.20914 117 8 115.209 8 113L8 5.00001C8 2.79087 6.20914 1 4 1H-2.38419e-07' stroke={stroke} />
    </svg>
  );
}
